import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";

export default (props) => {
  const columns = [
    {
      field: "serviceId",
      label: "Služba",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "node",
      label: "Server",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "endpoint",
      label: "URL služby",
      type: ColumnType.TEXT,
      width: "25%",
    },
    {
      field: "enabled",
      label: "Aktivní",
      type: ColumnType.YESNO,
      width: "5%",
    },
    {
      field: "status",
      label: "Stav služby",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "lastError",
      label: "Poslední chyba",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "lastErrorLocation",
      label: "Chyba - lokace",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "lastErrorTime",
      label: "Čas poslední chyby",
      type: ColumnType.DATETIME,
      width: "5%",
    },
    {
      field: "lastSuccessTime",
      label: "Čas posledního úspěchu",
      type: ColumnType.DATETIME,
      width: "5%",
    },
    {
      field: "lastCheckedTime",
      label: "Čas poslední kontroly",
      type: ColumnType.DATETIME,
      width: "5%",
    },
    {
      field: "certificateStatus",
      label: "Stav certifikátu",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "certificateError",
      label: "Certifikát - chyba",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "certificateValidTo",
      label: "Platnost certifikátu do",
      type: ColumnType.DATE,
      width: "5%",
    },
    {
      field: "certificateLastCheckedTime",
      label: "Kontrola certifikátu",
      type: ColumnType.DATETIME,
      width: "5%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};
